export const styleConstants = {
    taskBarHeight: '64px',
    layoutContentMaxWidth: '1440px',
};
